import { render, staticRenderFns } from "./apportion.vue?vue&type=template&id=6d10985d&"
import script from "./apportion.vue?vue&type=script&lang=js&"
export * from "./apportion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports